/**
 * MemberTypeService
 * Service for MemberType entity operations
 * Route: api/member-types
 * Controller: MemberTypesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MemberTypeService
 * Handles member type CRUD operations (cached lookup table)
 * Maps to /api/member-types endpoint
 */
export class MemberTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MemberTypeService.DEFAULT_SERVICE_PATH,
            basePath: MemberTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MemberTypeService.DEFAULT_SERVICE_PATH = 'members';
MemberTypeService.BASE_PATH = 'api/member-types';
//# sourceMappingURL=MemberTypeService.js.map